module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/evaluation-small.b589efa54178dd9f116cf53efedeb921.jpg";